import dayjs from 'dayjs';
import { upperFirst } from '@mantine/hooks';

function formatMonthLabel(_ref) {
  var month = _ref.month,
      locale = _ref.locale,
      format = _ref.format;
  return upperFirst(dayjs(month).locale(locale).format(format));
}

export { formatMonthLabel };